import {
    DndContext,
    closestCenter,
    KeyboardSensor,
    PointerSensor,
    useSensor,
    useSensors,
    type DragEndEvent,
} from "@dnd-kit/core";
import {
    SortableContext,
    verticalListSortingStrategy,
} from "@dnd-kit/sortable";

import SortableTalentMini from "../../../components/SortableTalentMini";
import type { BrowseFilter, Platform, SelectedTalent, Talent, User } from "../../../shared/types";

export type ListCartProps = {
    talentOrder: string[];
    talent: Talent[];
    platforms: Platform[];
    filter: BrowseFilter;
    selectedTalent: SelectedTalent;
    notesBookerViewable?: boolean;
    notesRequired?: boolean;
    useCustomPrices?: boolean;
    listUid?: string;
    user: User | null | undefined;
    canReorder: boolean;
    onDragEnd: (event: DragEndEvent) => void;
    onNotesChange: (id: string, notes: string) => void;
    onRemove: (id: string) => void;
};

/** Selected-creator rail: notes, custom prices, drag order, remove. */
export function ListCart({
    talentOrder,
    talent,
    platforms,
    filter,
    selectedTalent,
    notesBookerViewable,
    notesRequired,
    useCustomPrices,
    listUid,
    user,
    canReorder,
    onDragEnd,
    onNotesChange,
    onRemove,
}: ListCartProps) {
    const dndSensors = useSensors(
        useSensor(PointerSensor, { activationConstraint: { distance: 8 } }),
        useSensor(KeyboardSensor),
    );

    return (
        <DndContext
            sensors={dndSensors}
            collisionDetection={closestCenter}
            onDragEnd={onDragEnd}
        >
            <SortableContext items={talentOrder} strategy={verticalListSortingStrategy}>
                {talentOrder.map((talId) => (
                    <SortableTalentMini
                        key={talId}
                        talId={talId}
                        talent={talent}
                        platforms={platforms}
                        filter={filter}
                        selectedTalent={selectedTalent}
                        notesBookerViewable={notesBookerViewable}
                        notesRequired={notesRequired}
                        useCustomPrices={useCustomPrices}
                        listUid={listUid}
                        user={user}
                        canReorder={canReorder}
                        onNotesChange={onNotesChange}
                        onRemove={onRemove}
                    />
                ))}
            </SortableContext>
        </DndContext>
    );
}
